module.exports = __webpack_public_path__ + "media/assets/blue-mail-b371cb8d6b27b35b6d54a69b583b47c57b3693df792f7f85fc35e8c4ddd0e41e.svg";